import { render, staticRenderFns } from "./magicIntroduce.vue?vue&type=template&id=12e7139a&scoped=true&"
import script from "./magicIntroduce.vue?vue&type=script&lang=js&"
export * from "./magicIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./magicIntroduce.vue?vue&type=style&index=0&id=12e7139a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e7139a",
  null
  
)

export default component.exports